/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Liveroomrowhint3Inputs */

const en_liveroomrowhint3 = /** @type {(inputs: Liveroomrowhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guests check in with the QR code on site and see who is there.`)
};

const de_liveroomrowhint3 = /** @type {(inputs: Liveroomrowhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gäste checken vor Ort per QR-Code ein und sehen, wer da ist.`)
};

/**
* | output |
* | --- |
* | "Guests check in with the QR code on site and see who is there." |
*
* @param {Liveroomrowhint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const liveroomrowhint3 = /** @type {((inputs?: Liveroomrowhint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Liveroomrowhint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_liveroomrowhint3(inputs)
	return de_liveroomrowhint3(inputs)
});
export { liveroomrowhint3 as "liveRoomRowHint" }